import Vue from "vue";
import partner from "../../../static/json/partner.json";
//功能模块：合作伙伴
export default Vue.extend({
    name: "partners",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        contents: function () {
            var temp = partner['partners'];
            var url = "../../../static/img/index/";
            for (var i = 0; i < temp['img'].length; i++) {
                temp['img'][i] = url + temp['img'][i];
            }
            return temp;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/about/partners.vue
// module id = null
// module chunks = 